import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ErrorComponent } from './error.component';

@NgModule({
    declarations: [ErrorComponent],
    imports: [
        RouterModule.forChild([{
            path: 'Error/RamasseMiette',
            component: ErrorComponent
        }])
    ],
    exports: [RouterModule]
})
export class ErrorModule {

}
